angular.module('bizmetryApp')
    .controller('EditClientDialogController', function (
        $scope, $q, $mdDialog, $mdToast, $timeout,
        ClientService, ReferenceDataService, TemplateInstanceService, dialogService,
        client, profile, clientTypes, environments
    ) {
        var vm = this;

        // ===== RAW ENVIRONMENTS =====
        vm.environments = (environments || []).map(function (refEnv) {
            var clientEnv = (client.environments || []).find(function (ce) { return ce.id === refEnv.id; });
            return {
                id: refEnv.id,
                name: refEnv.name,
                envType: refEnv.envType || null,
                envTypeId: refEnv.envTypeId || null,
                agentId: refEnv.agent_id || null,
                agentStatus: refEnv.agent_status || null,
                agentLastSyncupTs: refEnv.agent_last_syncup_ts || null,
                templateInstanceId: refEnv.templateInstanceId || null,
                templateInstanceStatus: refEnv.templateInstanceStatus || null,
                templateInstanceVersion: refEnv.templateInstanceVersion || null,
                description: refEnv.description || '',
                enabled: clientEnv ? clientEnv.enabled : false
            };
        });

        // ===== CLIENT TYPES =====
        vm.clientTypes         = [];
        vm.commonClientTypes   = [];   // ✅ pre-computed
        vm.specificClientTypes = [];   // ✅ pre-computed
        vm.loadingClientTypes  = true;
        vm.templateInstancesByEnvId = {};

        // ===== MODEL =====
        vm.model = angular.copy(client);
        vm.model.clientType = null;

        // ===== ENVIRONMENT SELECTION =====
        vm.selectedEnvIds         = vm.environments.filter(function (e) { return e.enabled; }).map(function (e) { return e.id; });
        vm.originalSelectedEnvIds = vm.selectedEnvIds.slice();
        vm.allSelected  = false;
        vm.isSaving     = false;
        vm.predefinedHeaders = [];

    require('../ClientEnvironmentMappings.js').bind(vm, client);

        // =====================================================================
        // HELPERS
        // =====================================================================

        vm.getEnvNameById = function (envId) {
            var env = vm.environments.find(function (e) { return e.id === envId; });
            return env ? env.name : envId;
        };

        vm.isEnvDisabledForClientType = function (envId) {
            if (!vm.model.clientType || !vm.model.clientType.id) { return true; }
            if (vm.model.clientType.isCommon) { return false; }
            return (vm.model.clientType.envIds || []).indexOf(envId) === -1;
        };

        vm.getSelectedClientType = function () {
            if (!vm.model.clientType) { return null; }
            return vm.clientTypes.find(function (ct) { return ct.id === vm.model.clientType.id; }) || null;
        };

        // ✅ Basados en arrays pre-computados
        vm.hasCommonClientTypes   = function () { return vm.commonClientTypes.length > 0; };
        vm.hasSpecificClientTypes = function () { return vm.specificClientTypes.length > 0; };

        // =====================================================================
        // ✅ splitClientTypesByScope — definida ANTES de loadTemplateInstances
        // =====================================================================

        function splitClientTypesByScope() {
            vm.commonClientTypes   = vm.clientTypes.filter(function (ct) { return ct.isCommon === true; });
            vm.specificClientTypes = vm.clientTypes.filter(function (ct) { return ct.isCommon !== true; });
        }

        // =====================================================================
        // IP ADDRESS — CIDR validation
        // =====================================================================

    // =====================================================================
        // INIT
        // =====================================================================

        loadTemplateInstancesAndBuildClientTypes();
        loadPredefinedHeaders();
        updateAllSelectedState();

        // =====================================================================
        // LOAD TEMPLATE INSTANCES & BUILD CLIENT TYPES
        // =====================================================================

        function loadTemplateInstancesAndBuildClientTypes() {
            vm.loadingClientTypes = true;

            // ✅ Sin agentStatus — solo necesitamos template publicado
            var eligibleEnvs = vm.environments.filter(function (env) {
                return env.templateInstanceStatus === 'PUBLISHED' && env.templateInstanceId;
            });

            if (eligibleEnvs.length === 0) {
                // ✅ Sin fallback a locals — lista vacía → badge
                vm.clientTypes = [];
                splitClientTypesByScope();
                restoreClientType();
                vm.loadingClientTypes = false;
                // ✅ $timeout: liberar el flag DESPUÉS del digest que procesa el $watch
                $timeout(function () { isRestoringFromBackend = false; }, 0);
                return;
            }

            var uniqueTemplateIds = [];
            var seen = {};
            eligibleEnvs.forEach(function (env) {
                if (!seen[env.templateInstanceId]) {
                    seen[env.templateInstanceId] = true;
                    uniqueTemplateIds.push(env.templateInstanceId);
                }
            });

            var fetchPromises = uniqueTemplateIds.map(function (tid) {
                return TemplateInstanceService.getTemplateInstanceById(tid)
                    .then(function (response) { return response.data; })
                    .catch(function (err) {
                        console.error('Error loading template instance:', tid, err);
                        return null;
                    });
            });

            $q.all(fetchPromises).then(function (results) {
                var validTemplates = results.filter(function (t) { return t != null; });

                if (validTemplates.length === 0) {
                    // ✅ Sin fallback a locals — lista vacía → badge
                    vm.clientTypes = [];
                    splitClientTypesByScope();
                    restoreClientType();
                    vm.loadingClientTypes = false;
                    $timeout(function () { isRestoringFromBackend = false; }, 0);
                    return;
                }

                var templateToEnvIds = {};
                eligibleEnvs.forEach(function (env) {
                    if (!templateToEnvIds[env.templateInstanceId]) { templateToEnvIds[env.templateInstanceId] = []; }
                    templateToEnvIds[env.templateInstanceId].push(env.id);
                });

                var templateById = {};
                validTemplates.forEach(function (ti) { templateById[ti.id] = ti; });
                eligibleEnvs.forEach(function (env) {
                    var ti = templateById[env.templateInstanceId];
                    if (ti) { vm.templateInstancesByEnvId[env.id] = ti; }
                });

                vm.clientTypes = buildAllClientTypes(validTemplates, eligibleEnvs, templateToEnvIds);
                splitClientTypesByScope(); // ✅
                restoreClientType();       // ✅ después de split

                console.log('✅ Client types loaded:', vm.clientTypes.length,
                    '(common:', vm.commonClientTypes.length,
                    ', specific:', vm.specificClientTypes.length, ')');

                vm.loadingClientTypes  = false;
                $timeout(function () { isRestoringFromBackend = false; }, 0); // ✅ después del digest
            });
        }

        function buildAllClientTypes(templateInstances, eligibleEnvs, templateToEnvIds) {
            if (!templateInstances || templateInstances.length === 0) { return []; }

            var sorted = templateInstances.slice().sort(function (a, b) {
                var vA = a.version || a.templateVersion || '0';
                var vB = b.version || b.templateVersion || '0';
                return vB.localeCompare(vA, undefined, { numeric: true });
            });

            var ctMap = {};
            sorted.forEach(function (ti) {
                var envIds = templateToEnvIds[ti.id] || [];
                var cts = extractClientTypes(ti);
                cts.forEach(function (ct) {
                    if (!ctMap[ct.id]) { ctMap[ct.id] = angular.extend({}, ct, { envIds: [] }); }
                    envIds.forEach(function (envId) {
                        if (ctMap[ct.id].envIds.indexOf(envId) === -1) { ctMap[ct.id].envIds.push(envId); }
                    });
                });
            });

            var allEligibleEnvIds = eligibleEnvs.map(function (e) { return e.id; });
            var result = [];
            Object.keys(ctMap).forEach(function (id) {
                var ct = ctMap[id];
                var isCommon = allEligibleEnvIds.every(function (envId) { return ct.envIds.indexOf(envId) !== -1; });
                result.push(angular.extend({}, ct, { isCommon: isCommon }));
            });

            return result.sort(function (a, b) {
                if (a.isCommon && !b.isCommon) { return -1; }
                if (!a.isCommon && b.isCommon) { return 1; }
                return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
            });
        }

        function extractClientTypes(templateInstance) {
            try {
                var config = templateInstance.templateConfig;
                if (!config || !config.client_types) { return []; }
                return config.client_types.filter(function (ct) { return ct.enabled !== false; });
            } catch (e) { return []; }
        }

        function restoreClientType() {
            if (client.clientTypeId) {
                vm.model.clientType = vm.clientTypes.find(function (ct) { return ct.id === client.clientTypeId; }) || null;
            }
        }

        // =====================================================================
        // WATCH clientType — wipe envs en cambio manual, no en restore
        // =====================================================================

        var isRestoringFromBackend = true;

        $scope.$watch('vm.model.clientType', function (newVal, oldVal) {
            if (isRestoringFromBackend) { return; }
            if (newVal === oldVal) { return; }
            vm.selectedEnvIds = [];
            vm.allSelected = false;
        });

        // =====================================================================
        // PREDEFINED HEADERS
        // =====================================================================

        function loadPredefinedHeaders() {
            ReferenceDataService.getReferenceData('HTTP_HEADER_TYPE')
                .then(function (response) {
                    vm.predefinedHeaders = response.data || [];

                })
                .catch(function () {
                    console.error('Error loading HTTP headers');
                    vm.predefinedHeaders = [];
                });
        }

        // =====================================================================
        // ENVIRONMENT SELECTION
        // =====================================================================

        vm.toggleEnv = function (envId) {
            if (vm.isEnvDisabledForClientType(envId)) { return; }
            var idx = vm.selectedEnvIds.indexOf(envId);
            if (idx > -1) { vm.selectedEnvIds.splice(idx, 1); }
            else { vm.selectedEnvIds.push(envId); }
            updateAllSelectedState();
        };

        vm.isEnvSelected = function (envId) { return vm.selectedEnvIds.indexOf(envId) > -1; };

        vm.toggleSelectAll = function () {
            var enabledEnvIds = vm.environments
                .filter(function (env) { return !vm.isEnvDisabledForClientType(env.id); })
                .map(function (env) { return env.id; });

            if (vm.allSelected) {
                vm.selectedEnvIds = [];
                vm.allSelected = false;
            } else {
                vm.selectedEnvIds = enabledEnvIds.slice();
                vm.allSelected = enabledEnvIds.length > 0;
            }
        };

        function updateAllSelectedState() {
            var enabledEnvs = vm.environments.filter(function (env) { return !vm.isEnvDisabledForClientType(env.id); });
            vm.allSelected = enabledEnvs.length > 0 &&
                enabledEnvs.every(function (env) { return vm.selectedEnvIds.indexOf(env.id) > -1; });
        }

        // =====================================================================
        // FORM VALIDATION
        // =====================================================================

        vm.isFormValid    = function () { return $scope.clientForm && $scope.clientForm.$valid; };

        vm.isFormDisabled = function () {
            if (!vm.model.name || !vm.model.name.trim()) { return true; }
            if (!vm.model.clientType) { return true; }
            if (vm.invalidMappingEnvironments().length) { return true; }
            return vm.isSaving;
        };

        vm.isFormDirty = function () {
            if (!vm.model.clientType) { return false; }
            var isNameDirty        = vm.model.name !== client.name;
            var isDescDirty        = (vm.model.description || '') !== (client.description || '');
            var isTypeDirty        = vm.model.clientType.id !== client.clientTypeId;
            var isEnvDirty         = JSON.stringify(vm.selectedEnvIds.slice().sort()) !== JSON.stringify(vm.originalSelectedEnvIds.slice().sort());
            return isNameDirty || isDescDirty || isTypeDirty || isEnvDirty || vm.environmentMappingsDirty();
        };

        // =====================================================================
        // UPDATE CLIENT
        // =====================================================================

        vm.updateClient = function () {
            if (vm.isFormDisabled() || !vm.isFormDirty() || vm.isSaving) { return; }
            vm.isSaving = true;

            var payload = {
                name: vm.model.name,
                description: vm.model.description,
                enabled: vm.model.enabled,
                type: { id: vm.model.clientType.id, type: vm.model.clientType.name },
                requiresAttention: false,
                environments: vm.environments.map(function (env) {
                    return { id: env.id, name: env.name, enabled: vm.selectedEnvIds.indexOf(env.id) > -1, clientMappings: vm.environmentMappingPayload(env.id) };
                })
            };

            ClientService.patchClient(profile.id, vm.model.id, payload)
                .then(function () {
                    $mdToast.show($mdToast.simple().textContent('Client updated successfully!').position('top right').hideDelay(3000));
                    $mdDialog.hide(true);
                })
                .catch(function (err) {
                    var errorMessage = 'An error occurred while updating the client.';
                    if (err.data && err.data.message) { errorMessage = err.data.message; }
                    else if (err.statusText)           { errorMessage = err.statusText; }
                    dialogService.showErrorDialog('Update Failed', errorMessage);
                })
                .finally(function () { vm.isSaving = false; });
        };

        // =====================================================================
        // CANCEL
        // =====================================================================

        vm.cancel = function () { $mdDialog.cancel(); };

        // =====================================================================
    });